import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Link,
  useLocation,
  useNavigate,
  useSearchParams,
} from "react-router-dom";
import { getListStores } from "../../../redux/actions/storeActions";
import {
  addNewSection,
  deleteSection,
  getListSections,
} from "../../../redux/actions/sectionActions";
import DefaultLayout from "../../../layouts/DefaultLayout";
import Loader from "../../../components/Loader";
import Alert from "../../../components/Alert";
import { baseURLFile } from "../../../constants";
import Select from "react-select";
import { toast } from "react-toastify";
import ConfirmationModal from "../../../components/ConfirmationModal";
import Paginate from "../../../components/Paginate";

function SectionScreen() {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const dispatch = useDispatch();
  const page = searchParams.get("page") || "1";

  const [eventType, setEventType] = useState("");
  const [sectionId, setSectionId] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [loadEvent, setLoadEvent] = useState(false);

  const [storeSelect, setStoreSelect] = useState("");
  const [storeSelectError, setStoreSelectError] = useState("");

  const [sectionName, setSectionName] = useState("");
  const [sectionNameError, setSectionNameError] = useState("");

  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;

  const listStores = useSelector((state) => state.getListStores);
  const { stores, loadingListStores, errorListStores } = listStores;

  const listSections = useSelector((state) => state.getListSection);
  const { sections, loadingListSection, errorListSection, pages } =
    listSections;

  const sectionAdd = useSelector((state) => state.createNewSection);
  const { loadingSectionAdd, errorSectionAdd, successSectionAdd } = sectionAdd;

  const sectionDelete = useSelector((state) => state.deleteSection);
  const { loadingSectionDelete, errorSectionDelete, successSectionDelete } =
    sectionDelete;

  const redirect = "/";

  useEffect(() => {
    if (!userInfo) {
      navigate(redirect);
    } else {
      dispatch(getListStores("0"));
      dispatch(getListSections(page));
    }
  }, [navigate, userInfo, dispatch, page]);

  useEffect(() => {
    if (successSectionAdd) {
      setStoreSelect("");
      setSectionName("");
      dispatch(getListStores("0"));
      dispatch(getListSections("1"));
    }
  }, [successSectionAdd]);

  useEffect(() => {
    if (successSectionDelete) {
      dispatch(getListStores("0"));
      dispatch(getListSections("1"));
    }
  }, [successSectionDelete]);

  return (
    <DefaultLayout>
      <div>
        <div className="flex flex-row text-sm items-center my-1">
          {/* home */}
          <a href="/dashboard">
            <div className="flex flex-row  items-center hover:text-black ">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                className="w-4 h-4"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="m2.25 12 8.954-8.955c.44-.439 1.152-.439 1.591 0L21.75 12M4.5 9.75v10.125c0 .621.504 1.125 1.125 1.125H9.75v-4.875c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21h4.125c.621 0 1.125-.504 1.125-1.125V9.75M8.25 21h8.25"
                />
              </svg>
              <span className="mx-1">Dashboard</span>
            </div>
          </a>
          <span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
              className="w-4 h-4"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="m8.25 4.5 7.5 7.5-7.5 7.5"
              />
            </svg>
          </span>
          <div className="">Sections List</div>
        </div>
        {/*  */}
        <div className="flex flex-row justify-between  items-center my-3">
          <div className="mx-1 font-bold text-black ">Add New Section</div>
        </div>
        <div className="rounded-sm border border-stroke bg-white px-5 pt-6 pb-2.5 shadow-default  ">
          <div className="container mx-auto flex flex-col">
            <div className="flex md:flex-row flex-col  ">
              {/*  */}
              <div className="md:w-1/2 w-full  md:pr-1 my-1">
                <div className="text-[#000000bf] font-bold text-xs  mb-1">
                  Select Store <strong className="text-danger">*</strong>
                </div>
                <div>
                  <Select
                    value={storeSelect}
                    onChange={(option) => {
                      setStoreSelect(option);
                      // filter
                    }}
                    options={stores?.map((store) => ({
                      value: store.id,
                      label: store.store_name,
                    }))}
                    filterOption={(option, inputValue) =>
                      option.label
                        .toLowerCase()
                        .includes(inputValue.toLowerCase())
                    }
                    className="text-sm"
                    placeholder="Select a Store..."
                    isSearchable
                    styles={{
                      control: (base, state) => ({
                        ...base,
                        background: "#fff",
                        border: storeSelectError
                          ? "1px solid #d34053"
                          : "1px solid #979fd38a",
                        boxShadow: state.isFocused ? "none" : "none",
                        "&:hover": {
                          border: "1px solid #979fd38a",
                        },
                      }),
                      option: (base) => ({
                        ...base,
                        display: "flex",
                        alignItems: "center",
                      }),
                      singleValue: (base) => ({
                        ...base,
                        display: "flex",
                        alignItems: "center",
                      }),
                    }}
                  />
                  <div className=" text-[8px] text-danger">
                    {storeSelectError ? storeSelectError : ""}
                  </div>
                </div>
              </div>
              {/*  */}
              <div className="md:w-1/2 w-full  md:pr-1 my-1">
                <div className="text-[#000000bf] font-bold text-xs  mb-1">
                  Section Name <strong className="text-danger">*</strong>
                </div>
                <div>
                  <input
                    className={` outline-none border ${
                      sectionNameError ? "border-danger" : "border-[#979fd38a]"
                    } px-3 py-2 w-full rounded text-sm`}
                    type="text"
                    placeholder="Section Name"
                    value={sectionName}
                    onChange={(v) => setSectionName(v.target.value)}
                  />
                  <div className=" text-[8px] text-danger">
                    {sectionNameError ? sectionNameError : ""}
                  </div>
                </div>
              </div>
            </div>
            {/*  */}
            <div className="my-3 ">
              <div className="flex flex-row items-center justify-end my-3">
                <button
                  onClick={async () => {
                    setStoreSelectError("");
                    setStoreSelect("");
                    setSectionNameError("");
                    setSectionName("");
                  }}
                  className="text-white bg-danger text-sm px-5 py-2 mx-2 rounded-full"
                >
                  Cancel
                </button>
                <button
                  onClick={async () => {
                    var check = true;
                    setStoreSelectError("");
                    setSectionNameError("");

                    if (storeSelect === "" || storeSelect.value === "") {
                      setStoreSelectError("This field is required.");
                      check = false;
                    }

                    if (sectionName === "") {
                      setSectionNameError("These fields are required.");
                      check = false;
                    }

                    if (check) {
                      // setLoadEvent(true);
                      await dispatch(
                        addNewSection({
                          section_name: sectionName,
                          section_store: storeSelect.value,
                        })
                      ).then(() => {});
                      // setLoadEvent(false);
                    } else {
                      toast.error(
                        "Some fields are empty or invalid. please try again"
                      );
                    }
                  }}
                  className="text-white bg-[#0388A6] text-sm px-5 py-2 mx-2 rounded-full"
                >
                  {loadingSectionAdd ? "Loading ..." : "Create Section"}
                </button>
              </div>
            </div>
          </div>
        </div>
        {/*  */}
        <div className="flex flex-row justify-between  items-center my-3">
          <div className="mx-1 font-bold text-black ">Sections List</div>
        </div>
        <div className="rounded-sm border border-stroke bg-white px-5 pt-6 pb-2.5 shadow-default  ">
          <div className="container mx-auto flex flex-col">
            {/*  */}
            <div className="w-full overflow-x-auto ">
              <table className="w-full table-auto">
                <thead>
                  <tr className=" bg-[#F3F5FB] text-left ">
                    <th className="min-w-[30px] py-4 px-4 font-bold text-[#8E8E8E] text-xs w-max">
                      #
                    </th>
                    <th className="min-w-[120px] py-4 px-4 font-bold text-[#8E8E8E] text-xs w-max">
                      Section Name
                    </th>
                    <th className="min-w-[60px] py-4 px-4 font-bold text-[#8E8E8E] text-xs w-max ">
                      Store Name
                    </th>
                    <th className="min-w-[120px] py-4 px-4 font-bold text-[#8E8E8E] text-xs w-max">
                      Store logo
                    </th>
                    <th className="py-4 px-4 font-bold text-[#8E8E8E] text-xs w-max">
                      Operations
                    </th>
                  </tr>
                </thead>
                {/*  */}
                <tbody>
                  {loadingListSection ? (
                    <Loader />
                  ) : errorListSection ? (
                    <Alert message={errorListSection} />
                  ) : (
                    sections?.map((item, index) => (
                      <tr key={index}>
                        <td className=" py-1 px-4 min-w-[120px]  ">
                          <p className="text-black  text-xs w-max  ">
                            #{item.id}
                          </p>
                        </td>
                        <td className=" py-1 px-4 min-w-[120px]  ">
                          <p className="text-black  text-xs w-max  ">
                            {item.section_name ?? "---"}
                          </p>
                        </td>
                        <td className=" py-1 px-4 min-w-[120px]  ">
                          <p className="text-black  text-xs w-max  ">
                            {item.store?.store_name ?? "---"}
                          </p>
                        </td>
                        <td className=" py-1 px-4 min-w-[120px]  ">
                          <p className="text-black  text-xs w-max  ">
                            <img
                              src={baseURLFile + item.store?.store_logo}
                              className="size-11 rounded border-white border"
                            />
                          </p>
                        </td>

                        <td className=" py-1 px-4 min-w-[120px]  ">
                          <p className="text-black  text-xs w-max flex flex-row  ">
                            <div
                              onClick={() => {
                                setEventType("delete");
                                setSectionId(item.id);
                                setIsOpen(true);
                              }}
                              className="mx-1 delete-class cursor-pointer"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke-width="1.5"
                                stroke="currentColor"
                                className="w-5 h-5 bg-danger rounded p-1 text-white text-center text-xs"
                              >
                                <path
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  d="m20.25 7.5-.625 10.632a2.25 2.25 0 0 1-2.247 2.118H6.622a2.25 2.25 0 0 1-2.247-2.118L3.75 7.5m6 4.125 2.25 2.25m0 0 2.25 2.25M12 13.875l2.25-2.25M12 13.875l-2.25 2.25M3.375 7.5h17.25c.621 0 1.125-.504 1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125H3.375c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125Z"
                                />
                              </svg>
                            </div>
                          </p>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
            <div className="">
              <Paginate
                route={"/sections?"}
                search={""}
                page={page}
                pages={pages}
              />
            </div>
          </div>
        </div>
        <div className="grid md:grid-cols-2 w-full container mt-5"></div>
        <ConfirmationModal
          isOpen={isOpen}
          message={
            eventType === "delete"
              ? "Are you sure you want to delete this Section?"
              : "Are you sure ?"
          }
          onConfirm={async () => {
            if (eventType === "cancel") {
              setIsOpen(false);
              setEventType("");
              setLoadEvent(false);
              setSectionId("");
            } else if (eventType === "delete" && sectionId !== "") {
              setLoadEvent(true);
              dispatch(deleteSection(sectionId));
              setIsOpen(false);
              setEventType("");
              setLoadEvent(false);
            } else {
              setIsOpen(false);
              setEventType("");
              setLoadEvent(false);
              setSectionId("");
            }
          }}
          onCancel={() => {
            setIsOpen(false);
            setEventType("");
            setLoadEvent(false);
            setSectionId("");
          }}
          loadEvent={loadEvent}
        />
      </div>
    </DefaultLayout>
  );
}

export default SectionScreen;
